module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


// WEBPACK FOOTER //
// ./node_modules/babel-runtime/core-js/symbol/iterator.js